import { Component, Input, Self } from '@angular/core';
import { CmsArea } from '@domgen/dgx-fe-cms';
import { GAPage } from '@domgen/dgx-fe-ga';
import { SeoPage } from '@domgen/dgx-fe-seo';
import { ContactUsComponentService } from '../../services/contact-us-component/contact-us-component.service';
import { EditableArea } from '@magnolia/angular-editor';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
  templateUrl: './contact-us.component.html',
  providers: [ContactUsComponentService],
  standalone: true,
  imports: [NgIf, EditableArea, AsyncPipe],
})
@GAPage()
@SeoPage()
export class ContactUsComponent {
  @Input() banner!: CmsArea;
  @Input() main!: CmsArea;
  @Input() contactUsPanels!: CmsArea;

  constructor(@Self() readonly cs: ContactUsComponentService) {}
}
